export const customerOnboardingFeatureName = 'customerOnboarding';
